module.exports = "/build/web/svg/sponsor/espn-wit.497b5fdc5ad7d44b533c82842288633e.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/espn-wit.svg
// module id = 209
// module chunks = 24